import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/vin/{vin} â Ð²ÑÐµ ÑÐ¿Ð¾Ð¼Ð¸Ð½Ð°Ð½Ð¸Ñ VIN Ð² Ð¾ÑÑÑÑÐ°Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ°:
// Ð¾ÑÐ²ÐµÑ Ð½Ð° Ð²Ð¾Ð¿ÑÐ¾Ñ Â«Ð¿Ð¾ÑÐµÐ¼Ñ ÑÑÐ¾Ð¹ Ð¼Ð°ÑÐ¸Ð½Ñ Ð½ÐµÑ Ð½Ð° Ð²Ð¸ÑÑÐ¸Ð½ÐµÂ».
const getStockImportByVin = (vin) => {
  return api.get(`/api/crm/cars/stockImport/vin/${encodeURIComponent(vin)}`);
};

export default getStockImportByVin;
